<template>
    <span @click="navigate" class="btn btn-default">
        <i class="fa fa-angle-double-left"></i> Back
    </span>
</template>

<script>
    export default {
        props: {
            routeName: {
                type: String,
                default: 'records_table',
                required: false,
            }
        },

        methods: {
            navigate() {
                this.$store.commit('unlockSearchInProgress');

                this.$router.push({name: this.routeName});
            }
        }
    }


</script>

<style scoped>

</style>
